import React from 'react';

// Named-filter banner for a list screen reached via an "In Use" drill-down
// link (ui-architecture.md, "Usage Count Column ('In Use')") — states which
// filter value is active in plain text, with a Clear action, rather than
// leaving the user to infer it from a badge or an unopened Filters panel.
function FilterBanner({ message, onClear }) {
  return (
    <div style={{ margin: '12px 24px 0', padding: '8px 12px', background: '#eef4fc', border: '1px solid #bcd6f5', borderRadius: 6, fontSize: 13, color: '#1c4e80', display: 'flex', alignItems: 'center', gap: 8 }}>
      {message}
      <button
        type="button"
        onClick={onClear}
        style={{ background: 'none', border: 'none', color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', fontSize: 13, padding: 0 }}
      >
        Clear
      </button>
    </div>
  );
}

export default FilterBanner;
